import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core'
import { Option } from '../../ui/ui.types'

import { DrrModalComponent } from '../../ui/drr-modal/drr-modal.component'
import { ButtonComponent } from '../../ui/aaa-button/button.component'

export const PASSENGERS_OPTIONS = [
  { label: $localize`Zero`, value: '0' },
  { label: $localize`One`, value: '1' },
  { label: $localize`Two`, value: '2' },
  { label: $localize`Three or More`, value: '3 OR MORE' },
]

@Component({
  selector: 'app-passengers',
  templateUrl: './passengers.component.html',
  styleUrls: ['./passengers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DrrModalComponent, ButtonComponent],
})
export class PassengersComponent {
  @Input() isOpen = true
  @Input() customClass: string
  @Output() close: EventEmitter<void> = new EventEmitter()
  @Output() select: EventEmitter<Option> = new EventEmitter()

  passengerOptions = PASSENGERS_OPTIONS

  selectOption(option: Option) {
    this.select.emit({ ...option })
  }

  handleDismiss() {
    this.close.emit()
  }
}
